import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://the-pivot-logical-battleground.onrender.com/api/comments';

export const fetchComments = createAsyncThunk('comments/fetchComments', async (postId, {rejectWithValue}) => {
  try {
    const token = localStorage.getItem('token');

    const res = await axios.get(`${API_URL}/${postId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

// 댓글 생성 액션 정의
export const createComment = createAsyncThunk(
  'comments/createComment', 
  async (commentData, { rejectWithValue }) => {
    try {
      // 1. 로컬스토리지에서 토큰 추출
      const token = localStorage.getItem('token');

      // 2. 요청 시 헤더에 Authorization 추가
      const res = await axios.post(API_URL, commentData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return res.data;
    } catch (err) {
      // 서버에서 보내는 에러 메시지를 Redux 상태로 전달
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 댓글 좋아요 액션 정의
// complete
export const toggleCommentLike = createAsyncThunk('comments/toggleLike', async ({ commentId }, {rejectWithValue}) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post(`${API_URL}/${commentId}/like`, {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return res.data;

  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

// [추가 필수] 댓글 삭제 액션 정의
// complete
export const deleteComment = createAsyncThunk('comments/deleteComment', async ({ commentId }, { rejectWithValue }) => {
  try { 
    const token = localStorage.getItem('token');
    const res = await axios.delete(`${API_URL}/${commentId}`, { 
      headers: { 
        Authorization: `Bearer ${token}` 
      },
  });
  return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

const commentsSlice = createSlice({
  name: 'comments',
  initialState: { list: [], loading: false },
  reducers: {
    clearComments: (state) => { state.list = []; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchComments.fulfilled, (state, action) => { state.list = action.payload; })
      .addCase(createComment.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(toggleCommentLike.fulfilled, (state, action) => {
        const index = state.list.findIndex(c => c._id === action.payload._id);
        if (index !== -1) state.list[index] = action.payload;
      })
      .addCase(deleteComment.fulfilled, (state, action) => {
        const deletedcommentId = action.payload.id;
        state.list = state.list.filter(c => c._id !== deletedcommentId);
        console.log("댓글 삭제 완료 :", deletedcommentId);
      });
  }
});

export const { clearComments } = commentsSlice.actions;
export default commentsSlice.reducer;